// const Host = "https://booksmmapi.rentchicken.net/api";
// const Host = "http://127.0.0.1:8000/api";
const Host = "https://site.booksmm.com/api";
export const api_Routes = {
  Auth: {
    login: `${Host}/user/login`,
    subscribe: `${Host}/user/subscribe`,
    subscribeEmail: `${Host}/user/subscribeEmail`,
    add: `${Host}/user/register`,
    verifyaccount: `${Host}/user/register/verification`,
    Resendverifyaccount: `${Host}/user/register/resendVerification`,
    SendEmailForForgetPassword: `${Host}/user/forgetPassword/step1`,
    VerficationPasswordByEmail: `${Host}/user/forgetPassword/step2`,
    ResetPassword: `${Host}/user/forgetPassword/step3`,
    ForgetPasswordResend: `${Host}/user/forgetPassword/resendVerification`,
  },
  Search: {
    view: `${Host}/panels/search`,
    servers: `${Host}/services/search`,
  },
  AddPanel: {
    add: `${Host}/panel`,
  },
  PaymentMethods: {
    get: `${Host}/getpaymentmethods`,
  },
  HomePage: {
    view: `${Host}/homepage`,
  },
  Providers: {
    view: `${Host}/panels/search`,
    getOne: (id) => `${Host}/panels/${id}`,
    add_rate: `${Host}/review`,
    getPanelByAuth: `${Host}/getPanelByIdAuth`,
    getPanelById: (id) => `${Host}/getPanelsByIdIdAuth/${id}`,
    getPanelsByAuth: `${Host}/getPanelsByIdAuth`,
    editMyPanel: `${Host}/editPanel`,
    edit: (id) => `${Host}/editPanel/${id}`,
    getServiceById: (id) => `${Host}/getServiceById/${id}`,
    addReviewsService: `${Host}/addReviewsService`,
  },
  OurServices: {
    view: `${Host}/OurServices`,
    add: `${Host}/request`,
  },
  OurOffer: {
    view: `${Host}/offers`,
    getOne: (id) => `${Host}/offer/${id}`,
    add: `${Host}/offerInvoice`,
  },
  invoice: {
    getOne: (id) => `${Host}/GetInvoice?invoice_id=${id}`,
    getOneByGuest: (id) => `${Host}/GetInvoiceByGuest?invoice_id=${id}`,
    getOneOffer: (id) => `${Host}/GetOfferInvoice?invoice_id=${id}`,
    getOneOfferByGuest: (id) => `${Host}/GetOfferInvoiceByGuest?invoice_id=${id}`,
    pay: `${Host}/PayInvoice`,
    payByGuest: `${Host}/PayInvoiceByGuest`,
  },
  Header: {
    getMyNotifications: `${Host}/getMyNotifications`,
    ReadNotification: `${Host}/readNotifications`,
    ReadAllNotification: `${Host}/readallNotifications`,
    getMarketers: `${Host}/getMarketers`,
    getResellers: `${Host}/resellers`,
    getReseller: `${Host}/resellers`,
  },
  profile: {
    showprofile: `${Host}/dashboard/showProfile`,
    updateprofile: `${Host}/dashboard/updateProfile`,
    changePassword: {
      sendCode: `${Host}/dashboard/sendOtpForChangePassword`,
      verifyCode: `${Host}/dashboard/verifyOtpChangePassword`,
      changePassword: `${Host}/dashboard/ChangePassword`,
    },
  },
  dashboard: {
    overView: {
      view: `${Host}/dashboard/user`,
    },
    tickets: {
      view: `${Host}/dashboard/support/category`,
      viewTicket: `${Host}/dashboard/support/TicketMessages/`,
      add: `${Host}/dashboard/support/createTicket`,
      addMessage: `${Host}/dashboard/support/createMessageTicket`,
      get_history: `${Host}/dashboard/support/historyTicket`,
    },
    orderhistory: {
      view: `${Host}/dashboard/filterOrders`,
      viewByOffer: `${Host}/dashboard/OrdersOfferHistory`,
      Statistics: `${Host}/dashboard/GetStatisticsOrder/`,
    },
    adhistory: {
      view: `${Host}/dashboard/filterAds`,
      Statistics: `${Host}/dashboard/GetStatisticsAd/`,
    },
  },
  Pin: {
    AddStatistics: `${Host}/addPinStatistics/`,
    OnSee: `${Host}/strorageViewsByPinActice`,
  },
  Banner: {
    AddStatistics: `${Host}/addBannerStatistics/`,
    OnSee: `${Host}/strorageViewsByBannerActive`,
  },
  FAQ: {
    view: `${Host}/faqs`,
  },
  Countries: {
    view: `${Host}/providers/countries`,
  },
  Settings: {
    View: `${Host}/settings`,
  },
  Reviews: {
    ServicesReviews: `${Host}/dashboard/reviews/services`,
    PanelsReviews: `${Host}/dashboard/reviews/panels`,
    DeletePanelReview: `${Host}/dashboard/reviews/panels/delete`,
    DeleteServiceReview: `${Host}/dashboard/reviews/services/delete`,
  },
  SocialGroup: {
    Whatsapp: `${Host}/dashboard/socialGroup/whatsapp`,
    Telegram: `${Host}/dashboard/socialGroup/telegram`,
    Skype: `${Host}/dashboard/socialGroup/skype`,
    Panels: `${Host}/dashboard/panels`,
    AddGroup: `${Host}/dashboard/group`,
  },
  Membership: {
    view: `${Host}/dashboard/memberships`,
    getOne: (id) => `${Host}/dashboard/membership/${id}`,
    GetAll:  `${Host}/dashboard/membershipSubscriptions`,
    getOneSubscription: (id) => `${Host}/dashboard/membershipSubscription?invoice_id=${id}`,
    pay: `${Host}/dashboard/PaySubscription`,
  },
  Pages: {
    View: `${Host}/pages`,
  },
  UserAds: {
    View: `${Host}/userads/ads`,
    GetOne: `${Host}/userads/ads/`,
    getCategories: `${Host}/userads/adcategories`,
    canAdd: `${Host}/userads/canAdd`,
    createAd: `${Host}/userads`,
    editAd: `${Host}/userads/editUserAds`,
    OnSee: `${Host}/userads/strorageViewsByAds`,
  },
  UserChat: {
    View: `${Host}/conversations`,
    Start: `${Host}/conversations/start`,
    SendMessage: `${Host}/conversations/message`,
    SendDirectMessage: `${Host}/conversations/direct_message`,
  },
  ResellerAd: {
    GetOne: `${Host}/resellers/ad`,
    Review: `${Host}/resellers/ad/review`,
    GetReviews: `${Host}/resellers/ad/reviews`,
    DeleteReview: `${Host}/resellers/ad/reviews/delete`,
  },
  Reseller: {
    Review: `${Host}/resellers/review`,
    GetReviews: `${Host}/resellers/reviews`,
    DeleteReview: `${Host}/resellers/reviews/delete`,
  },
};
